module.exports = __webpack_public_path__ + "img/9788997023189.4f159935.jpg";